interface Props {
  count?: number;
}

function SingleServiceSkeleton() {
  return (
    <div className="card">
      {/* Icon placeholder */}
      <div className="skeleton w-10 h-10 rounded-lg mb-3" />
      {/* Service name */}
      <div className="skeleton h-5 w-2/3 mb-2" />
      {/* Description */}
      <div className="skeleton h-4 w-full mb-1" />
      <div className="skeleton h-4 w-4/5" />
    </div>
  );
}

function CategoryGroupSkeleton() {
  return (
    <div>
      {/* Category heading */}
      <div className="skeleton h-6 w-48 mb-4" />
      <div className="grid md:grid-cols-3 gap-4">
        <SingleServiceSkeleton />
        <SingleServiceSkeleton />
        <SingleServiceSkeleton />
      </div>
    </div>
  );
}

export default function SkeletonServiceGroup({ count = 3 }: Props) {
  return (
    <div role="status" aria-busy="true" aria-label="Loading services" className="space-y-10">
      {Array.from({ length: count }, (_, i) => (
        <CategoryGroupSkeleton key={i} />
      ))}
    </div>
  );
}
